import React, { useState, useEffect } from "react";
import '../assets/css/js-code-editor.css';

const JsCodeEditor = ({ code, setCode, onChangeComplete }) => {
    const [lineCount, setLineCount] = useState(1);

    // Handle code input change
    const handleCodeChange = (e) => {
        const value = e.target.value;
        setCode(value);
        setLineCount(value.split("\n").length);

        if (onChangeComplete) {
            onChangeComplete(value);
        }
    };

    // Function to generate line numbers dynamically
    const generateLineNumbers = () => {
        let lines = [];
        for (let i = 1; i <= lineCount; i++) {
            lines.push(i);
        }
        return lines;
    };

    useEffect(() => {
        setLineCount(code.split("\n").length);
    }, [code]);

    return (
        <div className="editor-container">
            <div className="line-numbers">
                {generateLineNumbers().map((line, index) => (
                    <div key={index} className="line-number">{line}</div>
                ))}
            </div>

            <textarea
                className="code-textarea"
                value={code}
                onChange={handleCodeChange}
                placeholder="Write your JavaScript code here..."
                rows={lineCount}
            />
        </div>
    );
};

export default JsCodeEditor;
